module.exports = __webpack_public_path__ + "img/devias.6ddf4e1b.jpg";